import { useEffect, useRef } from "react";




export function Contact() {
    const focusRef = useRef(null);

    useEffect(() => {
        focusRef.current?.focus();
    }, []);



    return (
        <div className="bg-gray-100 text-gray-900 min-h-screen">
            <div ref={focusRef} tabIndex={0} className="sr-only">Start of [Page Name] Page</div>
            {/* Header Section */}
            <header className="rounded bg-indigo-800 py-6">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl font-bold text-white">Contact SendFalcon</h1>
                    <p className="mt-2 text-lg text-indigo-50">Get in Touch with Our Team</p>
                </div>
            </header>

            {/* Main Content */}
            <main className="container mx-auto px-4 py-12">
                {/* Contact Information Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Reach Out</h2>
                    <p className="text-gray-700 leading-relaxed mb-6">
                        At SendFalcon, we're here to support your business in deploying and managing our secure, self-hosted email service. Contact us for inquiries, technical support, or to learn more about how SendFalcon can enhance your communication infrastructure.
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="bg-indigo-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-xl font-bold text-white mb-2">General Inquiries</h3>
                            <p className="text-indigo-100">Email: info@SendFalcon.com</p>
                            <p className="text-indigo-100">Phone: +1 (555) 123-4567</p>
                        </div>
                        <div className="bg-indigo-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-xl font-bold text-white mb-2">Technical Support</h3>
                            <p className="text-indigo-100">Email: support@SendFalcon.com</p>
                            <p className="text-indigo-100">Phone: +1 (555) 987-6543</p>
                        </div>
                    </div>
                </section>

                {/* Office Information Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Our Office</h2>
                    <p className="text-gray-700 leading-relaxed">
                        Visit or mail us at our headquarters. We're happy to discuss how SendFalcon can be tailored to your business needs.
                    </p>
                    <div className="mt-4">
                        <p className="text-gray-700">SendFalcon Headquarters</p>
                        <p className="text-gray-700">123 Privacy Lane, Suite 100</p>
                        <p className="text-gray-700">Tech City, TC 12345, USA</p>
                    </div>
                </section>
            </main>
        </div >
    );
};